import React, { FC } from "react";
import { useController, useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import InputMask from "react-input-mask";

import { MaskedTextInputProps } from "./types";

const StyledFormMaskedInput: FC<MaskedTextInputProps> = (props) => {
  const {
    mask,
    name,
    title,
    rules,
    defaultValue = "",
    testId,
    ...inputProps
  } = props;

  const formContext = useFormContext();
  const {
    control,
    formState: { errors: { [name]: { message = "" } = {} } = {} },
  } = formContext;

  const {
    field: { value, onChange },
  } = useController({ name, control, rules, defaultValue });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.target;
    // TODO: move to a function
    const formattedValue = inputValue.replace(/\s/g, "");
    onChange(formattedValue);
  };

  return (
    <Box mb={2} textAlign="left">
      {title && (
        <Typography variant="subtitle2" color="grey800" mb={1}>
          {title}
        </Typography>
      )}
      <InputMask
        mask={mask}
        onChange={handleChange}
        value={value}
        maskChar={null}
      >
        {(inputMaskProps) => (
          <TextField
            {...inputProps}
            {...inputMaskProps}
            data-testid={testId || name}
            slotProps={{
              formHelperText: {
                "data-testid": name + "-error-message",
              },
            }}
            error={!!message}
            helperText={message}
          />
        )}
      </InputMask>
    </Box>
  );
};

export default StyledFormMaskedInput;
